import axios from 'axios';


var CancelToken = axios.CancelToken;
var get_cancels={};
var post_cancels={};

export function get(url, filters, route_name, is_uniq_url=false) {
  let cur_p=new Promise((resolve, reject) => {
    filters =  Object.assign({}, filters);

    switch (route_name) {
      /*case 'PickedWorks':
      case '_PickedWorks':
        filters =  Object.assign({'picked':'y'}, filters);
      break;*/

      case 'MyWorks':
      case '_MyWorks':
        filters =  Object.assign({'my':'y'}, filters);
      break;

      case 'LikedWorks':
      case '_LikedWorks':
        filters =  Object.assign({'liked':'true'}, filters);
      break;

      case 'SaleWorks':
      case '_SaleWorks':
        filters =  Object.assign({'saletype':'all'}, filters);
      break;

      case 'DebutWorks':
      case '_DebutWorks':
        filters =  Object.assign({'debut':'y'}, filters);
        if ( filters['period']==null || filters['period'].length==0 ) filters =  Object.assign({'period':'week'}, filters);
      break;
    }

    let count_on_page=$('#app-wrapper').attr('count_on_page');
    if ( count_on_page!=null && count_on_page.length>0 ) filters.count_on_page=count_on_page;

    let artist_id=$('#app-wrapper').attr('artist_id');
    if ( artist_id!=null && artist_id.length>0 ) filters.artist=artist_id;

    let gallery_id=$('#app-wrapper').attr('gallery_id');
    if ( gallery_id!=null && gallery_id.length>0 ) filters.gallery_sel=gallery_id;

    let exposition_id=$('#app-wrapper').attr('exposition_id');
    if ( exposition_id!=null && exposition_id.length>0 ) filters.exposition=exposition_id;

    let place_id=$('#app-wrapper').attr('place_id');
    if ( place_id!=null && place_id.length>0 ) filters.place=place_id;

    let set_id=$('#app-wrapper').attr('set_id');
    if ( set_id!=null && set_id.length>0 ) filters.set=set_id;

    let access_hash=$('#app-wrapper').attr('access_hash');
    if ( access_hash!=null && access_hash.length>0 ) filters.access_hash=access_hash;

    if ( $('#app-wrapper').attr('router')=='sets' ){
      filters.set_type=$('#app-wrapper').attr('set_type');

      let user_id=parseInt( $('#app-wrapper').attr('user_id') );
      if ( user_id>0 ) filters.user_id=user_id;
    }

    if ( $('#app-wrapper').attr('router')=='artists' ){
      filters.set_type='artists';

      let artist_type=$('#app-wrapper').attr('artist_type');
      if ( artist_type!=null && artist_type.length>0 ) filters.artist_type=artist_type;
    }

    let hash=url;
    if (!is_uniq_url) hash+='/'+JSON.stringify(filters);

    if ( get_cancels[hash]!=null ) get_cancels[hash]();
    let q=axios.get(url,{params: filters, cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        get_cancels[hash] = c;
      })}).then(
      response => {
        if (window.is_vue_log) {
          console.log('+get:'+hash);
          console.log('resolve url:'+url);
          console.log(filters);
        }
        delete get_cancels[hash];
        resolve(response);
      },

      response => {
        if (window.is_vue_log) {
          console.log('-get:'+hash);
        }
        delete get_cancels[hash];
        //reject(response);
      }
    );
  });

  return cur_p;
}

export function post(url, data) {
  let hash=url+'/'+JSON.stringify(data);

  let cur_p=new Promise((resolve, reject) => {
    axios.post(url,{params: Object.assign({}, data)}, {cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        post_cancels[hash] = c;
      })}).then(
        response => {
          if (window.is_vue_log) {
            console.log('+post:' + hash);
          }
          delete post_cancels[hash];
          resolve(response);
        },
        response => {
          if (window.is_vue_log) {
            console.log('-post:' + hash);
          }
          delete post_cancels[hash];
          //reject(response);
        }
      );
  });

  return cur_p;
}




//////////////////
// WEBPACK FOOTER
// ./src/api/index.js
// module id = null
// module chunks = 